/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum ProjectStateEvent {
	'INVALID' = -2, //not actually a valid state, only exists for error handling
	'BOOMED' = -1, //blow up
	'UNINITIALIZED' = 0, //default
	'PROJECTS_INITIALIZED' = 1,
	'PROJECT_SELECTED' = 2, //setup called, project selected
	'FULLY_LOADED' = 100, //baked potato
}

//copied from plan-state, slightly cleaned, can probably do something better, but dat consistency
export class ProjectStateLifeCycle {
	private stages = {
		[ProjectStateEvent.PROJECTS_INITIALIZED]: false,
		[ProjectStateEvent.PROJECT_SELECTED]: false,
	};

	public projectListLoaded(): ProjectStateEvent {
		return this.calcState(ProjectStateEvent.PROJECTS_INITIALIZED);
	}

	public projectSelected(): ProjectStateEvent {
		return this.calcState(ProjectStateEvent.PROJECT_SELECTED);
	}

	public boom(): ProjectStateEvent {
		this.stages[ProjectStateEvent.PROJECT_SELECTED] = false;
		return ProjectStateEvent.PROJECTS_INITIALIZED;
	}

	public reset(): ProjectStateEvent {
		Object.keys(this.stages).forEach((t) => (this.stages[t] = false));
		return ProjectStateEvent.UNINITIALIZED;
	}

	private calcState(key: ProjectStateEvent): ProjectStateEvent {
		if (this.stages[key] === undefined) {
			return ProjectStateEvent.INVALID;
		}
		this.stages[key] = true;
		const all = Object.keys(this.stages).every((t) => this.stages[t]);
		if (all) {
			return ProjectStateEvent.FULLY_LOADED;
		} else {
			return key;
		}
	}
}
